import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré al espacio con el plan exacto de la clase. El Tomo 2 es exactamente lo que necesitaba para mis grupos de principiantes. Nunca más improviso.',
  name: 'Florencia M.',
  city: 'Buenos Aires',
  role: 'Profe de Telas en Estudio Propio'
}, {
  quote: 'El Tomo 4, el de nivel avanzado, me cambió todo. El primer mes, alumnas que llevaban meses estancadas mejoraron visiblemente su técnica. El banco de figuras me da la tranquilidad que antes no tenía.',
  name: 'Camila R.',
  city: 'Rosario',
  role: 'Profe en Centro Deportivo'
}, {
  quote: 'El sistema de progresión es único en el mercado. 15 clases listas para usar en cada nivel, con las indicaciones técnicas descriptas paso a paso. Antes tardaba horas armando una secuencia. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  name: 'Valentina F.',
  city: 'Córdoba',
  role: 'Profe de Telas Grupal e Individual'
}, {
  quote: 'La Guía de Corrección del Bono 3 eliminó mi inseguridad al corregir. Ahora sé exactamente qué decir y cómo asistir. Mis alumnas sienten la diferencia y mis clases tienen otro nivel de profesionalismo.',
  name: 'Luciana P.',
  city: 'Tucumán',
  role: 'Profe Particular y en Gimnasio'
}, {
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión y la variedad de los 6 tomos. Las alumnas ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Marcela G.',
  city: 'Mendoza',
  role: 'Profe de Telas Online y Presencial'
}, {
  quote: 'El Script... bueno, el Tomo 6 de marketing me salvó de seguir dependiendo del boca a boca. Ahora tengo un sistema para atraer alumnos. Mi espacio está lleno por primera vez en dos años.',
  name: 'Laura V.',
  city: 'Santa Fe',
  role: 'Profe de Telas en Estudio Propio'
}, {
  quote: 'El Kit Emprendedora Fit del Pack Élite me cambió la cabeza. Nunca había dimensionado el potencial de profesionalizar mi imagen. Ahora trabajo con una seguridad que antes no tenía y cobro lo que realmente merezco.',
  name: 'Ana R.',
  city: 'Salta',
  role: 'Profe en Centro de Actividades Aéreas'
}];
export const TestimonialsExtended: React.FC = () => {
  return <section className="py-10 md:py-20 bg-white" data-id="element-421">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-422">
        <div className="text-center mb-8 md:mb-16" data-id="element-423">
          <h2 className="text-2xl md:text-4xl font-bold font-serif text-gray-900 mb-2 md:mb-4" data-id="element-424">
            Lo que dicen las profes que ya lo usan:
          </h2>
          <p className="text-base md:text-xl text-primary font-medium" data-id="element-425">
            +300 profes de telas de todo el país ya tienen su Profes de Telas
            Resuelto™
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-426">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`bg-gray-50 p-5 md:p-8 rounded-xl md:rounded-2xl border border-gray-100 shadow-sm relative flex flex-col ${index === testimonials.length - 1 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-427">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-gray-200 w-7 h-7 md:w-10 md:h-10" data-id="element-428" />

              <p className="text-sm md:text-base text-gray-700 italic mb-4 md:mb-6 relative z-10 flex-grow" data-id="element-429">
                "{testimonial.quote}"
              </p>

              <div className="pt-3 md:pt-4 border-t border-gray-200" data-id="element-430">
                <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-431">
                  {testimonial.name}
                </p>
                <div className="flex items-center gap-1 text-xs md:text-sm text-gray-500 mt-0.5 mb-0.5" data-id="element-432">
                  <span data-id="element-433">📍</span> {testimonial.city}
                </div>
                <p className="text-xs font-medium text-primary uppercase tracking-wide" data-id="element-434">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};